import classNames from 'classnames';
import React from 'react';
import SVG from 'react-inlinesvg';

import Button, { ButtonStyles } from '@Components/Buttons/Button';
import Row from '@Components/layout/Row';
import Typography from '@Components/Typography';
import { FaqCategoryFragment } from '@Graphql/graphqlTypes.generated';

import styles from '../FAQCategoriesContentItem/FAQCategoriesContentItem.module.scss';

interface FAQCategoriesContentItemProps {
  category: FaqCategoryFragment;
  onClick: () => void;
  active: boolean;
  children: React.ReactNode;
}

const returnIcon = (icon: string) => (
  <div className={styles.icon}>
    <SVG src={icon} />
  </div>
);

const MobileFaqContentItem: React.FC<FAQCategoriesContentItemProps> = ({ children, category, onClick, active }) => {
  return (
    <div className={classNames(styles.faqCategoriesContainerItem, { [styles.active]: active })}>
      <Button onClick={onClick} style={ButtonStyles.plain} className={styles.categoryButton}>
        <Row alignCenter constant>
          {category.icon && returnIcon(category.icon)}
          <Typography msg={category.name} tag="span" className={styles.categoryName} size="m" />
        </Row>
      </Button>
      <div className="content">{children}</div>
    </div>
  );
};

export default MobileFaqContentItem;
